/**
 * Created by mauget on 1/28/16.
 */

import fabric           from  'fabric.js/dist/fabric.require';


//======================================================================================
// Create a prototypical custom rounded rectangle class.
// Used for command and stage objects of behaviors and workflows.
// Targets Behaviors and Workflow canvases.
// -Lou Mauget January 28, 2016
//======================================================================================
export const LabeledRectClass = fabric.util.createClass(fabric.Rect, {

    type: 'labeledRect',

    initialize: function(opt) {
        const options = opt || {};
        const widgetWidth = 150;
        const widgetHeight = 44;
        const titleHeight = 22;

        this.callSuper('initialize', options);
        this.set('label', options.label || '');
        this.set('icon',  options.icon  || '');

        this.icon = this.icon || '';
        this.fillColor = options.fillColor || '#CCCCCC';

        this.width  = Number(options.width || widgetWidth);
        this.height = Number(options.height || widgetHeight);
        this.titleHeight = titleHeight;

        this.left = Number(this.left) - this.width /2;
        this.top  = Number(this.top)  - this.height/2;

        this.hasControls = true;
        this.hasRotatingPoint = false;
        this.objectCaching = false;
        this.visible = options.visible;
        this.hoverCursor = 'pointer';
    },

    toObject: function() {
        return fabric.util.object.extend(this.callSuper('toObject'), {
            label: this.get('label')
        });
    },

    preparedText: function(originalText, context) {
        let widgetWidth = parseInt(this.width);
        let text = originalText? originalText.split("\n")[0].split(" ") : '';
        let line = '', testLine = '';
        let done = false;
        let count = 0;
        while ( !done && count < text.length ) {
            testLine += text[count] + " ";
            let metrics = context.measureText(testLine);
            let testWidth = metrics.width;
            if (testWidth > widgetWidth) {
                if (line === '') {
                    line = testLine.substring(0, 19);
                }
                done = true;
            } else {
                line = testLine + " ";
                ++count;
            }
        }
        // PF-1918: Show ... for longer texts
        if (done) {
            line = line.substring(0, line.length-4) + '...';
            this.textOverflown = true;
        }

        return line;
    },

    _render: function(ctx) {
        // Don't call super. We don't use the Fabric.js base rectangle. We'll draw a rect with rounded corners.

        const
            x = this.width / 2,
            y = this.height / 2,
            radius = 12;

        ctx.lineWidth = 0.5;

        // Draw entire rounded rect clockwise from upper left corner. Split, fill, and label it afterward.

        ctx.beginPath();

        ctx.moveTo(-x, -(y - radius));

        // Top left rounded corner
        ctx.arcTo( -x, -y,
            -(x - radius), -y,
            radius);

        // Top border ... left-to-right
        ctx.lineTo( x - radius, -y);

        // Top right rounded corner
        ctx.arcTo( x, -y,
            x, -y + radius,
            radius);

        // Right border
        ctx.lineTo( x, y - radius );


        // Bottom right rounded corner
        ctx.arcTo(
            x, y,
            x - radius, y,
            radius);

        // Bottom border ... right-to-left
        ctx.lineTo( -(x - radius), y);

        // Bottom left rounded corner
        ctx.arcTo(
            -x, y,
            -x, y - radius,
            radius);

        // Left border via closePath
        ctx.closePath();

        ctx.fillStyle   = this.fillColor;
        ctx.strokeStyle = "#CCCCCC";
        ctx.fill();
        ctx.stroke();

        // -------------
        // Overwrite top with white title region:

        ctx.beginPath();

        ctx.moveTo(-x, -(y - radius));

        // Top left rounded corner
        ctx.arcTo( -x, -y,
            -(x - radius), -y,
            radius);

        // Top border ... left-to-right
        ctx.lineTo( x - radius, -y);

        // Top right rounded corner
        ctx.arcTo( x, -y,
            x, -y + radius,
            radius);

        // Right border
        ctx.lineTo( x, -(y - this.titleHeight));

        // Divider: right-to-left
        ctx.lineTo( -x, -(y - this.titleHeight));

        ctx.closePath();

        ctx.fillStyle   = '#FFFFFF';
        ctx.strokeStyle = this.fillColor;
        ctx.fill();
        ctx.stroke();

        // Insert the title and optional bottom text

        ctx.beginPath();

        ctx.font = '12px Sans-Serif';
        ctx.fillStyle = '#000000';
        ctx.textAlign = 'center';

        ctx.fillText(this.label, 0, -y + 15 );

        if (/*1 || */this.isTest) {
            this.widgetText = 'Test text. Test text.';
        }
        ctx.fillText( this.preparedText(this.widgetText, ctx), 0, -y + 35 );

        ctx.closePath();

    }
});

